module.exports = __webpack_public_path__ + "static/media/noti2.1e335c7e.png";